import {PropsWithChildren, useState} from "react";
import {
  StyledAccountDetailsFormLayoutWrapper,
  StyledAccountDetailsFormLayoutInfoWrapper,
  StyledCurrentAccountDetailsBox,
} from "./styles";
import {Button} from "antd";
import {useFetchAccountDetailsContext} from "../../../../connect-bank-account/context/fetch-account-details.context";
import {usePayoutSettingsContext} from "../../context";

export function AccountDetailsFormLayout({children}: PropsWithChildren) {
  const {state} = useFetchAccountDetailsContext();
  const hasAccountDetails = !!state.accountDetails?.bank;
  return (
    <div>
      <StyledAccountDetailsFormLayoutWrapper>
        {hasAccountDetails ? <HasConnectedAccount /> : <NoAccountConnected />}
        <div>{children}</div>
      </StyledAccountDetailsFormLayoutWrapper>
    </div>
  );
}

function NoAccountConnected() {
  return (
    <StyledAccountDetailsFormLayoutInfoWrapper>
      <p className="bold-text">
        Connect your bank account. This is where your earnings will be sent to
      </p>
    </StyledAccountDetailsFormLayoutInfoWrapper>
  );
}
function HasConnectedAccount() {
  const {state} = useFetchAccountDetailsContext();

  if (!state.accountDetails) {
    return <NoAccountConnected />;
  }
  return (
    <StyledAccountDetailsFormLayoutInfoWrapper>
      <p className="bold-text">Current details</p>
      <CurrentAccountDetailsBox
        accountName={state.accountDetails.bank.account_name}
        accountNumber={state.accountDetails.bank.account_number}
        bankName={state.accountDetails.bank.bank_name}
      />
      <p className="bold-text">
        Update your payout details. This is where your earnings will be sent to
      </p>
    </StyledAccountDetailsFormLayoutInfoWrapper>
  );
}

export function CurrentAccountDetailsBox({
  accountName,
  accountNumber,
  bankName,
}: {
  accountName: string;
  accountNumber?: string;
  bankName: string | null;
}) {
  return (
    <StyledCurrentAccountDetailsBox>
      <p>{accountName}</p>
      {bankName && accountNumber && (
        <p>
          <span>{bankName}</span> - <span className="bold-text">{accountNumber}</span>
        </p>
      )}
    </StyledCurrentAccountDetailsBox>
  );
}
